<template>
    <div class="form">
        <div class="vcore_row">
            <div class="vcore_col--md--6 vcore_col--sm--12">
                <div class="vcore_input-group">
                    <label class="vcore_input-label">Title</label>
                    <input
                            type="text"
                            class="vcore_input"
                            :value="prototype.title"
                            @input="titleUpdate"
                    />
                </div>
                <span class="vcore_input-addon">Name of the project.</span>
            </div>
            <div class="vcore_col--md--6 vcore_col--sm--12">
                <div class="vcore_input-group">
                    <label class="vcore_input-label">Path</label>
                    <input
                            type="text"
                            class="vcore_input"
                            :value="prototype.path"
                            @input="pathUpdate"
                    />
                </div>
                <span class="vcore_input-addon">Project URL. cbusertesting.com/{{ exampleURL }}/</span>
            </div>
            <div v-if="newProject" class="vcore_col--md--6 vcore_col--sm--12">
                <div class="vcore_input-group">
                    <label class="vcore_input-label">Project File</label>
                    <input
                            type="file"
                            name="file"
                            id="file"
                            class="file_input"
                            ref="file"
                            v-on:change="handleFileUpload()"
                    />
                    <!--<label for="file" class="file_input-label">Choose a file</label>-->
                    <hr class="underline">
                </div>
                <span class="vcore_input-addon">Select a .zip file to upload.</span>
            </div>
<!--            <div class="vcore_col&#45;&#45;xs&#45;&#45;5">-->
<!--                <div class="vcore_input-group">-->
<!--                    <label class="vcore_input-label">Project Dist Folder</label>-->
<!--                    <input type="text" value="Value" class="vcore_input"/>-->
<!--                    <span class="vcore_input-addon">Zip folder for faster upload</span>-->
<!--                </div>-->
<!--            </div>-->

        </div>
<!--        <div class="vcore_row divider">Optional</div>-->
<!--        <div class="vcore_row">-->
<!--            <div class="vcore_col&#45;&#45;xs&#45;&#45;5 no-padding-left">-->
<!--                <div class="vcore_input-group">-->
<!--                    <label class="vcore_input-label">Path</label>-->
<!--                    <input type="text" value="Value" class="vcore_input"/>-->
<!--                    <span class="vcore_input-addon">How the project will appear in the URL. Example: cbusertesting.com/EXAMPLE/</span>-->
<!--                </div>-->
<!--            </div>-->

<!--        </div>-->


    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: "PrototypeForm",
        props: {
          newProject: {
              type: Boolean
          }
        },
        computed: {
            ...mapGetters([
                "prototype",
                "file"
            ]),
            exampleURL: function () {
                if (this.prototype.path === "") {
                    return "EXAMPLE";
                } else {
                    return encodeURI(this.prototype.path);
                }
            }
        },
        methods: {
            titleUpdate(e){
                this.$store.commit("titleUpdate", e.target.value);
            },
            pathUpdate(e){
                this.$store.commit("pathUpdate", e.target.value);
            },
            handleFileUpload(){
                this.$store.commit("fileUpdate", this.$refs.file.files[0])
            }
        },
    }
</script>

<style lang="scss" scoped>
    .no-padding-left {
        padding-left: 0;
    }

    .vcore_input-label {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 33px;
        float: left;
        color: $color_black;
    }

    .divider {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 28px;
        line-height: 38px;
        text-align: left;
        color: $color_gray-3;
        margin-top: 25px;
    }

    .vcore_input-addon {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        //float: left;
        color: $color_gray-4;
    }

    .file_input {
        //visibility: hidden;
        width: 100%;
        line-height: 0;
    }

    .file_input-label {
        width: 150px;
        padding: 10px 20px;
        border-color: black;
        background-color: black;
        color: white;
    }

    .underline {
        position: relative;
        top: 3px;
    }

</style>
